import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { URLCHECKOUTVIEWDATA } from '../config/setup/setup';
import { getAppPlatform } from './device';

const getPaymentOptions = async ({
  dealId,
  dealVoucherProductId,
  quantity,
}) => {
  try {
    const data = {
      paymentViewRequest: {
        dealProducts: [
          {
            dealVoucherProductId,
            payDeposit: false,
            quantity,
          },
        ],
      },
    };
    const response = await axios(
      `${URLCHECKOUTVIEWDATA}/${dealId}?deliveryOptions=true`,
      {
        cache: false,
        data,
        headers: {
          'app-platform': getAppPlatform(),
          brand: process.env.NEXT_PUBLIC_BRAND || 'wowcher',
          'country-code': process.env.NEXT_PUBLIC_COUNTRY_CODE || 'gb',
          webapp: true,
        },
        method: 'POST',
      },
    );
    if (response) {
      return response.data.data;
    }

    return null;
  } catch {
    return null;
  }
};

export default getPaymentOptions;
